import {MediaMagnifierSlider} from 'modules/slider/components/MediaMagnifierSlider';
import style from './style.module.scss';
import {IBubble, IMedia} from 'modules/products/types';
import {FC} from 'react';

interface IProps {
    bubble?: IBubble;
    videoUrl?: string;
    images: string[];
    imagesAltText: string;
    videoImage: IMedia['videoPreview'];
}

const ProductGallery: FC<IProps> = ({bubble, images = [], imagesAltText, videoUrl, videoImage}) => {
    return (
        <div className={style.areaGallery}>
            <MediaMagnifierSlider
                bubble={bubble}
                images={images}
                imagesAltText={imagesAltText}
                videoUrl={videoUrl}
                videoImage={videoImage}
            />
        </div>
    );
};

export default ProductGallery;
